import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';

export const UPDATE_ORG_APP_SUBSCRIPTION_RESOURCE = 'updateOrgAppSubscription';

const updateOrgAppSubscriptionService = ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_ORG_APP_SUBSCRIPTION_RESOURCE,
      method: 'put',
      request: (body, callback, removeFromList, successKey, failedKey, t) => ({
        url: apiRoutes.organisationApps(),
        body,
        meta: {
          callback,
          ...(removeFromList
            ? {
                removeFromOtherList: {
                  resource: removeFromList.resource,
                  idProp: 'subscriptionId',
                  id: removeFromList.id,
                },
              }
            : {}),
          toaster: {
            onErrorMessage: createErrorMessage(t, failedKey),
            onSuccessMessage: t(successKey),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default updateOrgAppSubscriptionService;
